/* eslint react/forbid-prop-types:0 */
/* eslint react/no-did-mount-set-state:0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  button: {
    border: '0px',
    height: '36px',
    display: 'inline-block',
    borderRadius: '4px',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    padding: '0 18px',
    fontSize: '15px',
    fontWeight: 'bold',
    outline: 'none',
    WebkitBoxShadow: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    marginTop: '10px',
    verticalAlign: 'middle',
    textAlign: 'center',
  },
  buttonRed: {
    backgroundColor: '#e60023',
    color: '#fff',
  },
  buttonLightGrey: {
    backgroundColor: '#ebebeb',
    color: '#444',
  },
  buttonDarkGrey: {
    backgroundColor: '#333',
    color: '#fff',
  },
  buttonWhite: {
    backgroundColor: '#fff',
    color: '#444',
  },
  buttonWhiteBlueText: {
    backgroundColor: '#fff',
    color: '#0074e8',
  },
  buttonTransparent: {
    backgroundColor: 'transparent',
    border: '1px solid #fff',
    color: '#fff',
  },
  disabledButton: {
    backgroundColor: '#efefef',
    color: '#8e8e8e',
  },
  loadingSpinner: {
    padding: '0 10px',
    position: 'relative',
  },
  noStyles: {
    background: 'none',
    border: 'none',
    padding: '0',
    textAlign: 'left',
  },
};

export class Button extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loadingWidth: null,
      isMountedClientSide: false,
    };
  }

  componentDidMount() {
    let buttonWidth = 0;
    if (this._buttonRef) {
      buttonWidth =
        this._buttonRef.getBoundingClientRect().width +
        parseFloat(this._buttonRef.style.marginLeft) +
        parseFloat(this._buttonRef.style.marginRight);
      this.setState({ loadingWidth: buttonWidth });
    }
    this.setState({ isMountedClientSide: true });
  }

  renderSpinner() {
    return <div className="loadingSpinner" style={styles.loadingSpinner} />;
  }

  render() {
    const { loadingWidth } = this.state;
    const loading =
      this.props.loading ||
      (this.props.numServerRenderedPins > 0 && this.state.isMountedClientSide === false);
    let buttonClassName = this.props.className;
    let colorStyle = {};
    let noStyles = false;
    const classArray = buttonClassName.split(' ');
    if (this.props.disabled) {
      colorStyle = styles.disabledButton;
    } else if (classArray.indexOf('red') > -1) {
      colorStyle = styles.buttonRed;
    } else if (classArray.indexOf('lightGrey') > -1) {
      colorStyle = styles.buttonLightGrey;
    } else if (classArray.indexOf('darkGrey') > -1) {
      colorStyle = styles.buttonDarkGrey;
    } else if (classArray.indexOf('white') > -1) {
      colorStyle = styles.buttonWhite;
    } else if (classArray.indexOf('blueText') > -1) {
      colorStyle = styles.buttonWhiteBlueText;
    } else if (classArray.indexOf('noButtonStyles') > -1) {
      noStyles = true;
    } else if (
      classArray.indexOf('transparent') > -1 ||
      classArray.indexOf('blueTransparent') > -1
    ) {
      colorStyle = styles.buttonTransparent;
    }
    let buttonStyle = noStyles
      ? { ...styles.noStyles, ...this.props.styleOverrides }
      : { ...styles.button, ...colorStyle, ...this.props.styleOverrides };
    if (loading) {
      const loadingStyles = {
        cursor: 'default',
      };
      if (loadingWidth) {
        Object.assign(loadingStyles, { width: loadingWidth });
      }
      buttonStyle = { ...buttonStyle, ...loadingStyles };
    } else if (this.props.disabled) {
      buttonStyle = { ...buttonStyle, cursor: 'not-allowed' };
    } else {
      buttonClassName += ' active';
    }
    return (
      <button
        aria-label={this.props.accessibilityLabel}
        className={buttonClassName}
        disabled={this.props.disabled}
        href={this.props.href}
        id={this.props.id}
        onClick={this.props.onClick}
        ref={
          this.props.buttonRef ||
          ((ref) => {
            this._buttonRef = ref;
          })
        }
        style={buttonStyle}
        type={this.props.type}
      >
        {loading ? this.renderSpinner() : this.props.children}
      </button>
    );
  }
}

Button.propTypes = {
  accessibilityLabel: PropTypes.string,
  buttonRef: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  id: PropTypes.string,
  loading: PropTypes.bool,
  numServerRenderedPins: PropTypes.number,
  onClick: PropTypes.func,
  styleOverrides: PropTypes.object,
  type: PropTypes.string,
};

Button.defaultProps = {
  accessibilityLabel: '',
  styleOverrides: {},
  loading: false,
  type: 'button',
};

export default Button;
